module.exports = __webpack_public_path__ + "img/17.d5e30515.png";